module.exports = __webpack_public_path__ + "img/roboport-base.beb3d4fb.png";